import * as yup from "yup";

const tagsEditValidation = yup.object().shape({
  tagName: yup.string().required("tag name is required"),
});

export default tagsEditValidation;
